<template>
    <v-row>
        <NewUser :listId="list._id"
                 v-model="showNewPersonDialog">
        </NewUser>

        <ImporterNew v-model="showImporterDialog" type="users" />
        <v-col cols="12" class="mb-2 pb-0">
            <v-card color="kbWhite">
                <v-card-text>
                    <v-row class="pa-2"  align="center" >
                        <h4 id="title" class="hidden-xs-only kbDarkBlueText--text">{{list.name}}</h4>
                        <v-spacer></v-spacer>
                        <v-menu open-on-hover>
                            <template v-slot:activator="{ on }">
                                <v-btn icon v-on="on">
                                    <v-icon color="kbDarkBlueText">
                                        mdi-dots-vertical
                                    </v-icon>
                                </v-btn>
                            </template>

                            <v-list color="kbLight">
                                <v-list-item @click="createCampaign()">
                                    <v-list-item-title class="kbDarkBlueText--text">
                                        {{ `${$t('general.create')} ${$t('general.campaign')}` }}
                                    </v-list-item-title>
                                </v-list-item>

                                <v-list-item v-if="list.type === 'static'" @click="showNewPersonDialog = true">
                                    <v-list-item-title class="kbDarkBlueText--text">
                                        {{ $t('general.addNewPerson') }}
                                    </v-list-item-title>
                                </v-list-item>

                                <v-list-item v-if="list.type === 'static'" @click="showImporter()">
                                    <v-list-item-title class="kbDarkBlueText--text">
                                        {{ `${$t('general.import')} ${$t('general.people')}` }}
                                    </v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </v-row>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-text>
                    <v-row>
                        <v-col cols="12" class="hidden-sm-and-up">
                            <v-list two-line class="pa-0">
                                <v-list-item>
                                    <v-list-item-action>
                                        <v-icon large color="kbDarkBlue">list</v-icon>
                                    </v-list-item-action>

                                    <v-list-item-content>
                                        <v-list-item-title>{{list.name}}</v-list-item-title>
                                        <v-list-item-subtitle>{{ $t('general.listName') }}</v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list>
                        </v-col>

                        <v-col cols="12" sm="6">
                            <v-list two-line
                                    :color="$vuetify.theme.isDark ? 'kbSemiLightGray' : ''"
                                    rounded
                                    class="pa-0">
                                <v-list-item>
                                    <v-list-item-action>
                                        <v-icon large color="kbDarkBlue">people</v-icon>
                                    </v-list-item-action>

                                    <v-list-item-content>
                                        <v-list-item-title>{{list.totalUsers | formatNumber}} {{ $t('general.people') }}</v-list-item-title>
                                        <v-list-item-subtitle>{{ $t('general.peopleInTheList') }}</v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list>
                        </v-col>

                        <v-col cols="12" sm="6">
                            <v-list two-line
                                    :color="$vuetify.theme.isDark ? 'kbSemiLightGray' : ''"
                                    rounded
                                    class="pa-0">
                                <v-list-item>
                                    <v-list-item-action>
                                        <v-icon large color="kbDarkBlue">event_note</v-icon>
                                    </v-list-item-action>

                                    <v-list-item-content>
                                        <v-list-item-title v-if="list.createdAt">{{list.createdAt | moment('DD/MM/YYYY hh:mm a')}}</v-list-item-title>
                                        <v-list-item-subtitle>{{ $t('general.creationDate') }}</v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-col>

        <v-col cols="12">
            <ListUsers :list="list" />
        </v-col>
    </v-row>
</template>

<script>
import { EventBus } from '@/eventBus.js'
import ImporterNew from '@/components/ui/ImporterNew/ImporterNew'
import ListUsers from '@/pages/App/Communications/ListsPersons/ListUsers.vue'
import { mapState } from 'vuex'
import NewUser from '@/pages/App/People/dialogs/NewUser.vue'
import notifications from '@/libs/notifications'
export default {
  components: {
    ImporterNew,
    ListUsers,
    NewUser
  },
  computed: {
    ...mapState({
      list: state => state.listsPersons.list,
      importerProgress: state => state.listsPersons.importerProgress
    })
  },
  created () {
    this.getSpecificList()

    EventBus.$on('updateList', (listId) => {
      if (listId === this.list._id) {
        this.getSpecificList()
      }
    })
  },
  data () {
    return {
      showNewPersonDialog: false,
      showImporterDialog: false
    }
  },
  methods: {
    createCampaign () {
      this.$router.push({
        name: 'New Campaign',
        query: { list: this.list._id }
      })
    },
    getSpecificList () {
      this.$store.dispatch('getSpecificList', { listId: this.$route.params.listid })
    },
    showImporter () {
      if (!this.importerProgress.finish && this.importerProgress.show) return notifications.error(this.$t('general.waitUntilTheListGetsCreated'))
      this.$store.commit('SET_IMPORTER_STEP', 2)
      this.$store.commit('SET_IMPORTER_LIST_ID', this.list._id)
      this.$store.commit('SET_IMPORTER_SELECTION', 'existente')
      this.showImporterDialog = true
    }
  }
}
</script>
